import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  chgRdvMissionsFilter,
  chgVieMissionsFilter,
  chgEngagementsFilter,
  selectInOperationFilters,
} from "../../../redux/ReduxFilter";

const BlocFiltreOperation = (props) => {
  const { t } = useTranslation();
  const { orgunitPrincipalInOperation, espacePrincipalColidee } = props;
  const dispatch = useDispatch();
  const _selectInOperationFilters = useSelector(selectInOperationFilters);

  return (
    <div className="sliderSticky">
      <div className="enteteBlocFiltre">
        <span>{t("public.filtres.filtre22")}</span>
      </div>
      <Container fluid className="mb-3 d-flex align-items-center flex-nowrap containerFiltres">
        {orgunitPrincipalInOperation && orgunitPrincipalInOperation !== null && (
          <div className="m-1  align-items-center d-flex">
            <Form.Check
              className={_selectInOperationFilters.rdvmissions ? "filtreActif" : "filtreNonActif"}
              type="checkbox"
              label={t("public.filtres.filtre9")}
              id="rdvmissions"
              name="rdvmissions"
              onChange={(e) =>
                dispatch(chgRdvMissionsFilter(!_selectInOperationFilters.rdvmissions))
              }
              checked={_selectInOperationFilters.rdvmissions ? "checked" : ""}
            />
          </div>
        )}
        {espacePrincipalColidee !== 0 && (
          <div className="m-1  align-items-center d-flex">
            <Form.Check
              className={_selectInOperationFilters.viemissions ? "filtreActif" : "filtreNonActif"}
              type="checkbox"
              label={t("public.filtres.filtre8")}
              id="viemissions"
              name="viemissions"
              onChange={(e) =>
                dispatch(chgVieMissionsFilter(!_selectInOperationFilters.viemissions))
              }
              checked={_selectInOperationFilters.viemissions ? "checked" : ""}
            />
          </div>
        )}
        {/* <div className="m-1  align-items-center d-flex">
        <Form.Check
          className={_selectInOperationFilters.engagements ? "filtreActif" : "filtreNonActif"}
          type="checkbox"
          label={t("public.filtres.filtre21")}
          id="engagements"
          name="engagements"
          onChange={(e) => dispatch(chgEngagementsFilter(!_selectInOperationFilters.engagements))}
          checked={_selectInOperationFilters.engagements ? "checked" : ""}
        />
      </div> */}
      </Container>
    </div>
  );
};

export default BlocFiltreOperation;
